<template>
  <div class="link-container">
    <div class="link-title">友情链接</div>
    <div class="link-main">
      <a v-for="(item, index) in links" class="link-item" :href="item.linkUrl" target="_blank">{{ item.title }}</a>
    </div>
  </div>
</template>

<script>
import { getLinkList } from '@/api'

export default {
  data() {
    return {
      links: []
    }
  },
  mounted() {
    getLinkList().then(res => {
      this.links = res.data
    })
  }
}
</script>

<style lang="scss" scoped>
.link-container {
  width: 1200px;
  margin: 30px auto 0;
  background: #fff;
  padding: 30px 0;
  .link-title {
    font-size: 28px;
    font-weight: bold;
    color: #004089;
    line-height: 24px;
    border-left: 4px solid #0076FE;
    padding: 0 15px;
  }
  .link-main {
    margin-top: 30px;
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    .link-item {
      flex: 0 0 20%;
      font-size: 16px;
      text-decoration: none;
      color: #464D55;
      line-height: 32px;
      text-align: center;
    }
    .link-item:hover {
      color: #0077FE;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Link/index.vue